export default [
  {
    path: '/BannerList',
    name: 'BannerList',
    component: () => import('@/views/bodyApk/BannerList'),
    meta: {
      title: 'Banner管理'
    }
  },
  {
    path: '/classifyList',
    name: 'classifyList',
    component: () => import('@/views/bodyApk/ClassifyList'),
    meta: {
      title: '应用中心/分类管理'
    }
  },
  {
    path: '/brandList',
    name: 'brandList',
    component: () => import('@/views/bodyApk/BrandList'),
    meta: {
      title: '配置设置/品牌管理'
    }
  },
  {
    path: '/brandapkList',
    name: 'brandapkList',
    component: () => import('@/views/bodyApk/BrandapkList'),
    meta: {
      title: '配置设置/品牌应用管理'
    }
  },
  {
    path: '/apkInfoList',
    name: 'apkInfoList',
    component: () => import('@/views/bodyApk/apkInfoList'),
    meta: {
      title: '应用中心/应用管理'
    }
  },
  {
    path: '/apkReleaseList',
    name: 'apkreleaseList',
    component: () => import('@/views/bodyApk/apkreleaseList'),
    meta: {
      title: '应用中心/应用版本'
    }
  },
  {
    path: '/sourceList',
    name: 'sourceList',
    component: () => import('@/views/bodyApk/sourceList'),
    meta: {
      title: '应用中心/应用来源'
    }
  },
  {
    path: '/prefectureList',
    name: 'prefectureList',
    component: () => import('@/views/bodyApk/prefectureList'),
    meta: {
      title: '应用中心/精选专区'
    }
  },
  {
    path: '/classifyapkList',
    name: 'classifyapkList',
    component: () => import('@/views/bodyApk/ClassifyapkList'),
    meta: {
      title: '应用中心/应用分类'
    }
  },
  {
    path: '/apkSelectionList',
    name: 'apkSelectionList',
    component: () => import('@/views/bodyApk/ApkSelectionList'),
    meta: {
      title: '应用中心/精选推荐'
    }
  },
  {
    path: '/recommendList',
    name: 'recommendList',
    component: () => import('@/views/bodyApk/RecommendList'),
    meta: {
      title: '应用中心/更多推荐'
    }
  },
  {
    path: '/hotSearchList',
    name: 'hotSearchList',
    component: () => import('@/views/bodyApk/HotSearchList'),
    meta: {
      title: '应用中心/热门搜索'
    }
  },
  {
    path: '/apkChannelList',
    name: 'apkChannelList',
    component: () => import('@/views/bodyApk/apkChannelList'),
    meta: {
      title: '应用中心/机型过滤'
    }
  },
  {
    path: '/bodyApk/hideAppPage',
    name: 'hideAppPage',
    component: () => import('@/views/bodyApk/hideAppPage'),
    meta: {
      title: '应用中心/app桌面隐藏'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/bodyRouter.js